import gql from 'graphql-tag'

export const getOffersQuery = gql` {
  offers {
    id,
    budget,
    plot,
    client {
      id,
      email,
      firstName,
      lastName,
      location,
      message,
      phone,
      street,
      streetNumber,
      zip,
    },
    nodes,
    createdAt,
    updatedAt,
  }
}`

export const getAllNodesQuery = gql` {
  nodes(isVisible: false) {
    area,
    children,
    conflicts,
    description,
    elements {
      description,
      title,
      images,
    }
    id,
    images,
    isVisible,
    maxSelect,
    minSelect,
    nodeType,
    parent,
    path,
    price,
    pricePerArea,
    requires,
    template,
    title,
  }
}`

export const getNodesQuery = gql` {
  nodes {
    id,
    nodeType,
    title,
    description,
    images,
    minSelect,
    maxSelect,
    template,
    price,
    parent,
    path,
    children,
    requires,
    conflicts,
    elements {
      description,
      title,
      images,
    }
  }
}`

export const getUserQuery = gql` {
  user {
    id,
    firstName,
    lastName,
    email,
    role,
  }
}`

export const getUsersQuery = gql` {
  users {
    id,
    firstName,
    lastName,
    email,
    role,
  }
}`



// WEBPACK FOOTER //
// ./src/modules/admin/queries.js